import { APIService } from '../api/APIService';

export class PickupService {
    path: string;
    apiService: APIService;

    constructor(apiService: APIService) {
        const pickupURI = import.meta.env.VITE_DS_LOCATIONS_API;
        if (!pickupURI) {
            throw new Error('No pickup api uri path set');
        }
        this.path = pickupURI;
        this.apiService = apiService;
    }

    getLocations(): Promise<endpoints.LocationDTO> {
        return this.apiService.getData(this.path);
    }
}